<template>
  <el-popover :ref="'filter-pop-' + prop"
    popper-class="filter-pop"
    placement="bottom"
    :width="330"
    trigger="click"
    @show="onPopShow"
    @after-enter="afterPopShow">
    <div class="header-label" slot="reference">
      <span>{{label}}</span>
      <span :class="`iconfont icon-xiala1 ${ resetName === prop ? 'active_header' : ''}`"></span>
    </div>
    <div class="filter-panel">
      <div class="filter-panel-sort-wrap" v-if="useSort">
        <el-button 
          type="primary"
          plain
          size="mini" 
          :class="{active: sortType == 'asc'}"  
          icon="el-icon-sort-up"  
          @click="doSort('asc')">升序</el-button>
        <el-button 
          type="primary" 
          plain 
          size="mini" 
          :class="{active: sortType == 'desc'}"  
          icon="el-icon-sort-down" 
          @click="doSort('desc')">降序</el-button>
      </div>
      <div class="filter-panel-number-wrap" v-if="isNumberFilter">
        <span>数字筛选</span>
        <el-select 
          class="number-select"
          v-model="numCondition" 
          size="mini"
          placeholder="" 
          clearable>
          <el-option v-for="item in numberConditions" 
            :key="item.value" 
            :label="item.label" 
            :value="item.value"/>
        </el-select>
        <el-input-number 
          class="number-input"
          v-model="numVal" 
          :controls="false" 
          step-strictly 
          size="mini"/>
        <el-input-number 
          v-if="isRange"
          class="number-input"
          v-model="numVal2" 
          :controls="false" 
          step-strictly 
          size="mini"/>
      </div>
      <template v-if="!numCondition">
        <div class="filter-panel-input-wrap">
          <el-input
            class="filter-input"
            placeholder="请输入内容"
            size="mini"
            v-model="inputVal"
            @input="onFilter">
            <i slot="append" class="el-icon-search"></i>
          </el-input>
        </div>
        <div class="filter-panel-select-wrap">
          <el-checkbox class="condition-item" v-model="allChecked" @change="onCheckAllChange">全选</el-checkbox>
          <virtual-list 
            ref="conditionList"
            class="virtual-list"
            :data-key="'col'"
            :data-sources="conditionOptions"
            :data-component="itemComponent"
            :estimate-size="19"
            :item-class="'virtual-list-item'"
          />
        </div>
      </template>
      
      <div class="filter-panel-btn-wrap">
        <!-- <div class="sum_text" v-if="this.filterType === 'int' && !this.numCondition">总量：{{this.sumNum}}</div> -->
        <el-button size="mini" @click="resetFilter">重置</el-button>
        <el-button size="mini" @click="closePop">取消</el-button>
        <el-button type="primary" size="mini" @click="confirmFilter">确定</el-button>
      </div>
    </div>
  </el-popover>
</template>

<script>
import {debounce} from '@/utils'
import VirtualList from 'vue-virtual-scroll-list'
import CheckItem from './check-item'
export default {
  name: 'QTableHeaderFilter',
  components: {
    VirtualList,
    CheckItem
  },
  props: {
    actIndex:Number,
    table: String,
    searchReset: Boolean,
    label: String,
    prop: String,
    index: Number,
    bIndex: Number,
    // text number
    filterType: {
      type: String,
      default: 'text'
    },
    filterOptions: {
      type: Array,
      default() {
        return [];
      }
    },
    getFilterOptions: Function,
    useSort: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isNumberFilter() {
      return this.filterType === 'int';
    },
    isRange() {
      return this.numCondition == 7;
    },
    headerFilters() {
      return this.$store.state.headerFilters.filterCache;
    }
  },
  watch: {
    filterOptions: {
      handler(val) {
        if(this.filterType === 'int' && this.filterOptions[0]) {
            this.sumNum = this.filterOptions[0].sumNum
        }
        // if (Array.isArray(val)) {
          this.initCheck();
        // }
      },
      immediate: true
    },
    searchReset: { //时间搜索清空状态
      handler(val) {
        if (val === true) {
          this.resetName = -8
          this.$nextTick(_=>{
            this.confirmCheckedList = []
            this.lastFilter.number = []
          })
        }
      },
      immediate: true,
      deep:true,
    },
    inputVal: {
      handler(val) {
        if (val) {
          this.checkNum = true
        }else {
          this.checkNum = false
        }
      },
      deep: true
    },
  },
  data() {
    return {
      resetName: 0,
      btomIndex: -8,
      sumNum: 0,
      totalNum: 0,
      checkedDwon: false,
      inputVal: '',
      checkedList: [],
      confirmCheckedList: [],
      conditionOptions: [],
      initOptions: [],
      onFilter: () => {},
      allChecked: true,
      checkNum: false,
      numberConditions: [
        {label: '大于', value: 1},
        {label: '小于', value: 2},
        {label: '等于', value: 3},
        {label: '大于等于', value: 4},
        {label: '小于等于', value: 5},
        {label: '不等于', value: 6},
        {label: '介于', value: 7},
      ],
      numCondition: '',
      numVal: undefined,
      numVal2: undefined,
      isInited: false,
      confirmType: 0,
      sortType: '',
      // 做过一次搜索
      hasFiltered: false,

      isFirstShow: true,
      itemComponent: CheckItem,
      lastFilter: {
        number: [],
        sort: ''
      },
    }
  },
  methods: {
    init() {
      this.onFilter = debounce(this.filterOption, 500);
      this.$on('checkBoxValueChange', (col, checked, sumNum) => {
        const targetItem = this.conditionOptions.find((item) => item.col === col);
        if(checked) {
          this.sumNum =this.sumNum+Number(sumNum)   //选择时
        }else {                     
          this.sumNum -= sumNum   //取消时
        }
        if (targetItem) {
          targetItem.checked = checked;
          this.setCheckedList();
          
        }
      });
    },
    initCheck() {
      this.initOptions = this.filterOptions.map(item => ({
        ...item,
        checked: true
      }));
      this.conditionOptions = this.initOptions;
      this.onCheckAllChange(true);
    },
    resetModel() {
      this.sortType = '';
      this.numCondition = '';
      this.numVal = undefined;
      this.numVal2 = undefined;
      this.inputVal = '';
      this.allChecked = true;
      this.conditionOptions = this.initOptions;
      this.onCheckAllChange(true);
    },
    resetFilter() {
      this.hasFiltered = false;
      this.closePop();
      this.resetModel();
      this.confirmType = 1
      this.confirmFilter(); 
    },
    confirmFilter() {
      if(this.checkedList.length > 1000 && !this.allChecked) {
        this.$message.error('已超过1000条,请核对')
        return
      }
      // let listName = this.prop
      // let word = [`{${listName}:${this.checkedList}}`];
      this.confirmCheckedList = [...this.checkedList];
      let emitVal = {
        type: this.confirmType,
        prop: this.prop,
        cloumnType: this.filterType == 'int' ? 'numerical' : this.filterType,
        filter: {
          checked: this.confirmCheckedList,
          number: [],
          sort: '',
        }
      };
      // 选择了数字筛选时，不进行选择筛选
      if (this.isNumberFilter && this.numCondition) {
        // 数字筛选时，不进行条件选择
        emitVal.filter.checked = [];
        this.confirmCheckedList = [];

        emitVal.filter.number.push(this.numCondition, this.numVal);
        if (this.isRange) {
            emitVal.filter.number.push(this.numVal2);
 
        }
      }
      if(this.allChecked === true && this.checkNum === false) { //全选状态下
        this.resetName = 0
        if(this.numCondition) {  //为数字筛选时 不选多选 选择条件筛选 修改全选状态
          this.resetName = this.prop
          emitVal.type = 0
        }else if(this.sortType && !this.numCondition){ //当没有选择numberConditions和排序时
          emitVal.filter.checked = [""];
          this.resetName = this.prop
          emitVal.type = 0
        }else if(!this.numCondition && !this.sortType){ //当没有选择numberConditions和排序时
          emitVal.type = 1
          emitVal.filter.checked = [""];
          this.confirmType = 1
        }else if(this.sortType && this.numCondition) { //当选择numberConditions和排序时
          this.resetName = this.prop
          emitVal.type = 0
        }else if(!this.numCondition) { //当没有选择numberConditions
          emitVal.type = 1
          emitVal.filter.checked = [""];
          this.confirmType = 1
        }
         
      }else {
        this.resetName = this.prop
      }
      // 排序
      if (this.useSort) {
        emitVal.filter.sort = this.sortType;
        // if (!this.hasFiltered) {
        //   delete emitVal.filter.checked;
        //   delete emitVal.filter.number;
        // }
      }

      // if (this.isNumberFilter && this.numCondition || this.confirmCheckedList.length) {
      //   this.hasFiltered = true;
      // }
      if(this.filterType === 'int' && this.numCondition<7 && this.numCondition) {
        if(this.numVal === undefined) {
          this.$message({
            type: "success",
            message: "请输入完整的筛选条件"
          });
          return
        }
      }else if (this.filterType === 'int' && this.numCondition>6){
        if(this.numVal === undefined || this.numVal2 === undefined) {
          this.$message({
            type: "success",
            message: "请输入完整的筛选条件"
          });
          return
        }
      }
      
      this.lastFilter = {
        number: [...emitVal.filter.number],
        sort: emitVal.filter.sort
      }
      emitVal.filter.type = this.lastFilter.number[0]
      this.$emit('confirmFilter', emitVal);
      this.closePop();
      if(this.confirmType != 1) {
          this.$store.commit('headerFilters/setHeaderFilter', {
            table: this.table,
            column: this.prop,
            lastFilter: this.lastFilter,
            checkedList: this.confirmCheckedList,
            reset: this.resetName,
            sumNum: this.sumNum
          })
      }
      this.confirmType = 0
    },
    closePop() {
      const popRef = this.$refs['filter-pop-' + this.prop];
      if (popRef) {
        popRef.doClose();
      }
    },
    filterOption() {  //输入监听
    // console.log('aaaaaaa',inputVal)
      const lowerInputVal = this.inputVal+"".toLowerCase();
      var sumNum = 0
      if (!lowerInputVal) {
        this.conditionOptions = this.initOptions;
        this.onCheckAllChange(true);
        this.checkAllChecked();
        return;
      }

      this.conditionOptions = this.initOptions.filter(item => {
        const lowerItemLabel = item.col+"".toString().toLowerCase();
        return lowerItemLabel.includes(lowerInputVal);
      });
      this.conditionOptions.forEach(item=>{   //当输入匹配时 将新的内容计算汇总值
         sumNum = Number(item.totalNum)+sumNum
      })
      this.$nextTick(_=>{
        this.sumNum = sumNum
      })
      this.onCheckAllChange(true);
      this.checkAllChecked();
    },
    // 切换选中【全部】时，设置其他项选中状态
    onCheckAllChange(checked) {
      this.conditionOptions.forEach(item => item.checked = checked);
      this.checkedList = checked ? this.conditionOptions.map(item => item.col) : [];
      if(this.filterType === 'int' && this.filterOptions[0]) this.sumNum = checked ? this.filterOptions[0].sumNum : 0;
    },
    // 保存当前选中项
    setCheckedList() {
      this.checkedList = this.conditionOptions
        .filter(item => item.checked)
        .map(item => item.col);
      this.checkAllChecked();
    },
    checkAllChecked() {
      // 检查是否选中【全部】
      this.allChecked = this.checkedList.length === this.conditionOptions.length || this.checkedList.length > this.conditionOptions.length;
    },
    EchoDataJudgment(data) {
      if(data == 0) {
        return 0
      }else if(data) {
        return data
      }else {
        return undefined
      }
    },
    async onPopShow(index) {
      console.time('popShow')
      console.log('headerFilters:', this.headerFilters);
      const currentFilter = this.headerFilters 
      this.sortType = ""
      if (typeof this.getFilterOptions === 'function') {
        await this.getFilterOptions(this.prop,this.filterType);
      }
      if (currentFilter.length) {
        for(let i=0; i<currentFilter.length;i++) {
          if(currentFilter[i].column == this.prop && currentFilter[i].table == this.table) {
             this.confirmCheckedList = currentFilter[i].checkedList //选框内容已选回显
             this.sortType = currentFilter[i].lastFilter.sort
             this.lastFilter = currentFilter[i].lastFilter
             this.sumNum = currentFilter[i].sumNum
          }
        }  
      }
      this.conditionOptions = this.initOptions;
      this.inputVal = '';
      if(this.filterOptions.length == this.confirmCheckedList.length) this.confirmCheckedList = []
      // console.log(this.confirmCheckedList);
      if (this.confirmCheckedList.length) {
        console.log(this.checkedList.length ,this.conditionOptions.length);
        console.log(this.conditionOptions.map(v=>v.col));
        this.checkedList = [...this.confirmCheckedList];
        // 设置选中状态
        this.totalNum = 0
        this.conditionOptions.forEach(item => {
          item.checked = this.checkedList.includes(item.col);
          if(this.checkedList.includes(item.col)) { //当多次选择数字筛选 值的数量发生变化重新计算之前汇总值
            this.totalNum = this.totalNum + Number(item.totalNum)
          }
        });
        console.log(this.conditionOptions);
        this.sumNum = this.totalNum
      } else if (this.lastFilter.number.length) {
        this.numCondition = this.lastFilter.number[0] ||'';
        this.numVal = this.EchoDataJudgment(this.lastFilter.number[1])
        this.numVal2 = this.EchoDataJudgment(this.lastFilter.number[2])
        this.onCheckAllChange(true);
        
      }else {
        if(!this.sortType) {
          this.resetModel();
        }
      }
      if(!this.conditionOptions.filter(v=>!v.checked).length) {
        this.checkAllChecked();
      }
      
    },
    afterPopShow() {
      // 防止上次拉到底部，下次打开时显示空白
      if (this.isFirstShow) {
        this.isFirstShow = false;
      } else {
        this.scrollToTop();
      }
      console.timeEnd('popShow')
    },
    doSort(type) {
      if (!this.sortType || this.sortType != type) {
            this.sortType = type;
        
        // this.confirmFilter();
      } else {
        this.closePop();
      }
    },
    scrollToTop() {
      const virtualList = this.$refs.conditionList;
      if (virtualList) {
        virtualList.scrollToOffset(1);
      }
    }
  },
  created() {
    this.init();
  }
}
</script>
<style  scoped>
  .active_header {
    color: #E67B00
  }
</style>
<style lang="stylus" scoped>
.header-label
  display inline-flex
  align-items center
  line-height 23px
  width auto
  height auto
  cursor pointer
  padding 0
.filter-pop
  padding 10px 5px
.filter-panel
  .filter-input
    >>> .el-input-group__append
      padding 0 10px
  &-sort-wrap
    display flex
    align-items center
    justify-content space-around
    margin-bottom 10px
  &-number-wrap
    display flex 
    align-items center
    margin-bottom 10px
    >span 
      flex none 
      width 65px
    .number-select
      width 120px
    .number-input
      margin-left 5px
      width 80px
      >>> .el-input__inner
        padding 0 5px
  &-select-wrap
    box-sizing border-box
    padding 5px
    margin-top 10px
    width 100%
    // height 200px
    border 1px solid #DCDFE6
    // overflow auto
    .virtual-list
      width 100%
      height 200px
      overflow auto
    .condition-item
      display block
  &-btn-wrap
    position relative
    margin-top 10px
    text-align right
.active
  color #fff
  background-color #0BB78E
  border-color #0BB78E
.sum_text
  display inline-block
  position absolute
  left 0
  line-height 24px
</style>